import { render, staticRenderFns } from "./ConstantAnnotation.vue?vue&type=template&id=a1b73ad0&scoped=true"
import script from "./ConstantAnnotation.vue?vue&type=script&lang=js"
export * from "./ConstantAnnotation.vue?vue&type=script&lang=js"
import style0 from "./ConstantAnnotation.vue?vue&type=style&index=0&id=a1b73ad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b73ad0",
  null
  
)

export default component.exports